export default "__VITE_ASSET__e6f08e05__"